import type * as React from 'react';

import { cn } from '@/lib/utils';

interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Titre en gras (« Aucune requête en cours »). */
  title: React.ReactNode;
  /** Explication d'une phrase. */
  description?: React.ReactNode;
  /** Action (bouton `outline` `size="sm"`). */
  action?: React.ReactNode;
}

/** `empty` : état vide centré, 48px de respiration verticale, texte 13px. */
function EmptyState({
  title,
  description,
  action,
  className,
  ...props
}: EmptyStateProps): React.JSX.Element {
  return (
    <div
      className={cn(
        'grid justify-items-center gap-2 px-4 py-12 text-center text-[13px] leading-[18px] text-muted-foreground',
        className,
      )}
      {...props}
    >
      <b className="text-sm font-semibold text-foreground">{title}</b>
      {description !== undefined && description !== null ? <span>{description}</span> : null}
      {action !== undefined && action !== null ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}

/** État de chargement d'un bloc (texte discret, même rythme que `EmptyState`). */
function LoadingState({
  label = 'Chargement…',
  className,
}: {
  label?: string;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      role="status"
      className={cn('px-4 py-12 text-center text-[13px] text-muted-foreground', className)}
    >
      {label}
    </div>
  );
}

export { EmptyState, LoadingState };
